import { facilityAxios as axios } from "@/utils/axios";

/**
 * 健診施設取得APIを呼び出し、APIのレスポンスを返す
 * @returns APIのレスポンス
 */
export function getMedicalFacility() {
  return axios.get("/api/facility/user_facility/");
}
